/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { closeVeetingMeeting } from '../fn/veeting-meeting/close-veeting-meeting';
import { CloseVeetingMeeting$Params } from '../fn/veeting-meeting/close-veeting-meeting';
import { createVeetingMeeting } from '../fn/veeting-meeting/create-veeting-meeting';
import { CreateVeetingMeeting$Params } from '../fn/veeting-meeting/create-veeting-meeting';
import { getVeetingMeeting } from '../fn/veeting-meeting/get-veeting-meeting';
import { GetVeetingMeeting$Params } from '../fn/veeting-meeting/get-veeting-meeting';
import { VeetingMeetingDto } from '../models/veeting-meeting-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedVeetingMeetingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVeetingMeeting()` */
  static readonly GetVeetingMeetingPath = '/api/veeting-meeting';

  /**
   * Gets a veeting meeting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVeetingMeeting()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVeetingMeeting$Response(params?: GetVeetingMeeting$Params, context?: HttpContext): Observable<StrictHttpResponse<VeetingMeetingDto>> {
    return getVeetingMeeting(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a veeting meeting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVeetingMeeting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVeetingMeeting(params?: GetVeetingMeeting$Params, context?: HttpContext): Observable<VeetingMeetingDto> {
    return this.getVeetingMeeting$Response(params, context).pipe(
      map((r: StrictHttpResponse<VeetingMeetingDto>): VeetingMeetingDto => r.body)
    );
  }

  /** Path part for operation `createVeetingMeeting()` */
  static readonly CreateVeetingMeetingPath = '/api/veeting-meeting';

  /**
   * Starts a veeting meeting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVeetingMeeting()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVeetingMeeting$Response(params: CreateVeetingMeeting$Params, context?: HttpContext): Observable<StrictHttpResponse<VeetingMeetingDto>> {
    return createVeetingMeeting(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts a veeting meeting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVeetingMeeting$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVeetingMeeting(params: CreateVeetingMeeting$Params, context?: HttpContext): Observable<VeetingMeetingDto> {
    return this.createVeetingMeeting$Response(params, context).pipe(
      map((r: StrictHttpResponse<VeetingMeetingDto>): VeetingMeetingDto => r.body)
    );
  }

  /** Path part for operation `closeVeetingMeeting()` */
  static readonly CloseVeetingMeetingPath = '/api/veeting-meeting';

  /**
   * Ends a veeting meeting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeVeetingMeeting()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeVeetingMeeting$Response(params?: CloseVeetingMeeting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return closeVeetingMeeting(this.http, this.rootUrl, params, context);
  }

  /**
   * Ends a veeting meeting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closeVeetingMeeting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeVeetingMeeting(params?: CloseVeetingMeeting$Params, context?: HttpContext): Observable<void> {
    return this.closeVeetingMeeting$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
